import React, { useEffect, useState } from 'react';
import ConnectStripeModal from '../components/ConnectStripeModal';
import Company from '../types/company';

export const useConnectStripeModal = (
    company?: Company
): [typeof ConnectStripeModal, () => void, () => void, boolean] => {
    const [showModal, setShowModal] = useState(false);
    const handleOpen = () => setShowModal(true);
    const handleClose = () => setShowModal(false);

    useEffect(() => {
        setShowModal(!!company && !company?.stripe?.stripeId);
    }, [company]);

    return [ConnectStripeModal, handleOpen, handleClose, showModal];
};
